import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import {zhHant } from 'vuetify/locale';
import { VTreeview } from 'vuetify/labs/VTreeview'

const vuetify = createVuetify({
  defaults: {
    VInput: {
      color: 'primary',
    },
    VTextField: {
      color: 'primary',
    },
    VSelect: {
      itemColor: 'primary',
    },
    VCheckbox: {
      color: 'primary',
    },
    VRadio: {
      color: 'primary',
    },
    VRadioGroup: {
      color: 'primary',
    },
    VCardActions: {
      VBtn: { variant: 'elevated', color: 'grey-lighten-3' },
    },
    VBtn: {
      class: ['text-capitalize']
    },
    VSnackbar:{
      style:"padding-left:0px; padding-top:0px;",
    },
    VProgressLinear: {
      color: 'primary',
    },
  },
  components: {
    VTreeview,  
  },
  ssr: true,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    cspNonce: "dQw4w9WgXcQAGdsJdsfHdasF",
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
      colors: {
        error: "#ff5252",
      },
      variables: {
        'activated-opacity': 0.24,
        'disabled-opacity': 0.5,
        'medium-emphasis-opacity':0.7,
      }
      
    }
    },
  },
  locale: {
    locale: 'zhHant',
    fallback: 'zhHant',
    messages: { zhHant},
  },
});

export default vuetify;
